"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const componentlibrary_1 = require("@emarketer/componentlibrary");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const CheckmarkSvg_1 = __importDefault(require("../atoms/CheckmarkSvg"));
const Circle = styled_components_1.default.div `
  display: flex;
  width: 22px;
  height: 22px;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 100px;

  background: ${({ completed }) => (completed ? componentlibrary_1.COLOR.II.BLUE.DEFAULT : componentlibrary_1.COLOR.II.GRAY.LIGHT)};
  color: ${({ completed }) => (completed ? componentlibrary_1.COLOR.II.WHITE : componentlibrary_1.COLOR.II.BLUE.DEFAULT)};
  border: 1px solid ${componentlibrary_1.COLOR.II.BLUE.DEFAULT};

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.65;

  box-sizing: content-box;
`;
const Bar = styled_components_1.default.div `
  height: 10px;
  flex-grow: 1; // allow the Bar to take up the remaining space
  background: ${({ completed }) => (completed ? componentlibrary_1.COLOR.II.BLUE.DEFAULT : componentlibrary_1.COLOR.II.GRAY.LIGHT)};
  margin: 0 -8px;
  z-index: -1;
`;
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: space-between; // distribute items evenly
  margin-bottom: 42px;
  align-items: center;
  width: 100%;
`;
const ProgressBar = ({ progress = 0 }) => {
    // The first three steps are represented by numbers, while the final step is represented by a CheckmarkSVG.
    // If the progress reaches 4, it indicates that the final step (CheckmarkSVG) is completed.
    // If the step structure changes in the future, this approach may need to be revised.
    const steps = [1, 2, 3, react_1.default.createElement(CheckmarkSvg_1.default, { key: "4", completed: progress === 4 })];
    return (react_1.default.createElement(Container, null, steps.map((step, index) => {
        const isStepCompleted = progress >= index + 1;
        const isBarCompleted = progress > index + 1;
        const isNotLastStep = index < steps.length - 1;
        return (react_1.default.createElement(react_1.default.Fragment, { key: typeof step === 'number' ? step : 'checkmark' },
            react_1.default.createElement(Circle, { completed: isStepCompleted }, step),
            isNotLastStep && react_1.default.createElement(Bar, { completed: isBarCompleted })));
    })));
};
exports.default = ProgressBar;
